import * as React from 'react';
import {Link} from 'react-router-dom';

interface LpnCellProps {
  baseUrl: string;
  lpnBarcode?: string;
  lpnId?: number;
}
export function LpnCell({baseUrl, lpnBarcode, lpnId}: LpnCellProps) {
  if (lpnBarcode === null || lpnId === null) return <></>;
  return (
    <Link
      className="flexe-mui-data-grid-link-cell"
      title={lpnBarcode}
      to={`${baseUrl}/lpns?lpnId=${lpnId}`}
      target="_blank"
    >
      {lpnBarcode}
    </Link>
  );
}
